import React, { useState } from 'react';
import { Form, Input, Button, Typography, message } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';

const { Title } = Typography;

const ResetPassword = () => {
    const [password, setPassword] = useState('');
    const location = useLocation();
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get('token');

    const onFinish = (values) => {
        fetch('https://54.178.141.189/reset-password', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                token,
                newPassword: values.password,
            }),
        })
        .then(response => {
            if (response.ok) {
                return response.text();
            } else {
                throw new Error('Failed to reset password. Please try again.');
            }
        })
        .then(data => {
            message.success(data);
            
            setTimeout(() => {
                navigate('/login'); // Redirect to login page after successful reset
            }, 2000); // Delay for 2 seconds
        })
        .catch(error => {
            message.error(error.message);
        });
    };

    return (
        <div className="full-height-container">
            <div className="content-container-app">
                <Title level={1}>Reset Password</Title>
                <Form
                    name="reset-password"
                    onFinish={onFinish}
                >
                    <Form.Item
                        name="password"
                        label="New Password"
                        rules={[
                            {
                                required: true,
                                message: 'Please input your new password!',
                            },
                        ]}
                    >
                        <Input.Password onChange={e => setPassword(e.target.value)} />
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
};

export default ResetPassword;